import React from 'react';
import { MapPin, MessageCircle, Instagram, Clock } from 'lucide-react';
import { shopInfo } from '../data/mock';

const Contact = () => {
  const openWhatsApp = () => {
    window.open(`https://wa.me/${shopInfo.contact.whatsapp}`, '_blank');
  };

  const openInstagram = () => {
    window.open(`https://instagram.com/${shopInfo.contact.instagram}`, '_blank');
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="section-title mb-4">Visit Us</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-rose-400 mx-auto mb-6"></div>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            We're here to help you find the perfect fabric for your needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Location */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-amber-400 to-rose-400 flex items-center justify-center">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Our Location</h3>
                <p className="text-gray-700 leading-relaxed">
                  {shopInfo.location.address}<br />
                  {shopInfo.location.area}<br />
                  {shopInfo.location.city}, {shopInfo.location.state}
                </p>
              </div>
            </div>

            {/* Business Hours */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-amber-400 to-rose-400 flex items-center justify-center">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Business Hours</h3>
                <p className="text-gray-700 leading-relaxed">
                  Monday - Saturday: 10:00 AM - 8:00 PM<br />
                  Sunday: By Appointment
                </p>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Connect With Us</h3>
              <div className="flex space-x-4">
                <button
                  onClick={openWhatsApp}
                  className="social-button group"
                >
                  <MessageCircle className="w-6 h-6 text-white group-hover:scale-110 transition-transform duration-300" />
                  <span className="ml-2">WhatsApp</span>
                </button>
                <button
                  onClick={openInstagram}
                  className="social-button-instagram group"
                >
                  <Instagram className="w-6 h-6 text-white group-hover:scale-110 transition-transform duration-300" />
                  <span className="ml-2">Instagram</span>
                </button>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-2xl h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3303.482!2d74.787660!3d34.038368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzTCsDAyJzE4LjEiTiA3NMKwNDcnMTUuNiJF!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Global Boutique Location - Hyderpora Chowk, Srinagar"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
